export default "__VITE_ASSET__6zhOFjN2__"